// Multipart attachment fields — the add-attachment modal's three categories and a form's one picker.

// `bill_of_landing` is the server's spelling on every route that takes these three.
export const buildAttachmentsFormData = ({
  billOfLading,
  invoice,
  otherDocuments,
  removeFileIds,
}) => {
  const body = new FormData();
  (billOfLading ?? []).forEach((file) => body.append('bill_of_landing', file));
  (invoice ?? []).forEach((file) => body.append('invoice', file));
  (otherDocuments ?? []).forEach((file) => body.append('other_documents', file));
  if (removeFileIds?.length > 0) body.append('remove_file_ids', JSON.stringify(removeFileIds));
  return body;
};

// A form's picker has no categories, so every file is `other_documents`; removals go as one JSON array.
export const appendFormAttachments = (body, { attachments, removeFileIds }) => {
  (attachments ?? []).forEach((file) => body.append('other_documents', file));
  if (removeFileIds?.length > 0) body.append('removeFileIds', JSON.stringify(removeFileIds));
};

// `{ file: { id, filename } }` links → the picker's `existingAttachments`.
export const processExistingAttachments = (links) =>
  (links ?? [])
    .filter((link) => link?.file?.id != null)
    .map((link) => ({ id: Number(link.file.id), filename: link.file.filename }));
